/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterCriterionKind = typeof WebFilterCriterionKind[keyof typeof WebFilterCriterionKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterCriterionKind = {
  Transport: 'Transport',
  Nights: 'Nights',
  Destination: 'Destination',
  ProductTypes: 'ProductTypes',
  Departure: 'Departure',
  Products: 'Products',
  Price: 'Price',
  Seats: 'Seats',
  DaysBeforeDeparture: 'DaysBeforeDeparture',
  PublishedDays: 'PublishedDays',
  Dates: 'Dates',
} as const;
